<nz-spin [nzSpinning]="loading">
  <div class="wmsm-box">
    <form nz-form [formGroup]="validateForm">

      <div class="信息区" style="float: right"></div>
      <div class="查询区">
        <div class="查询条件" *ngIf="isShowCondition">

          <!-- 合同條件區 -->
          <nz-modal [(nzVisible)]="isVisible" nzTitle="{{'ContractInformationConditionArea' | translate}}"
            (nzOnCancel)="handleCancel()" (nzOnOk)="gettable1()">
            <ng-container *nzModalContent>


              <nz-form-item nzSpan="24">
                <nz-form-label nzSpan="8">{{"Site"|translate}}</nz-form-label>
                <nz-form-control nzSpan="8">
                  <nz-select formControlName="Site" nzAllowClear="true">
                    <nz-option *ngFor="let option of SiteList" [nzValue]="option.siteName"
                      [nzLabel]="option.siteName"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>

              <nz-form-item nzSpan="24">
                <nz-form-label nzSpan="8">{{"contractname"|translate}}</nz-form-label>
                <nz-form-control nzSpan="8">
                  <input nz-input formControlName="ContractName" />
                </nz-form-control>
              </nz-form-item>

              <nz-form-item nzSpan="24">
                <nz-form-label nzSpan="8">{{"ENcontractname"|translate}}</nz-form-label>
                <nz-form-control nzSpan="8">
                  <input nz-input formControlName="ContractNameEn" />
                </nz-form-control>
              </nz-form-item>


              <nz-form-item nzSpan="24">
                <nz-form-label nzSpan="8">{{"contractversion"|translate}}</nz-form-label>
                <nz-form-control nzSpan="8">
                  <input nz-input formControlName="ContractNameEn" />
                </nz-form-control>
              </nz-form-item>




            </ng-container>
          </nz-modal>

          <!-- 厂商信息 -->
          <nz-modal [(nzVisible)]="isVendor" nzTitle="{{'VendorInformation' | translate}}"
            (nzOnCancel)="isVendorCancel()" (nzOnOk)="isVendorOk()" nzWidth="800px">
            <ng-container *nzModalContent>
              <div nz-row style="margin-left: 50px;">
                <div nz-col>
                  <nz-form-item>
                    <nz-form-label>
                      <div class="width-100-percent label-font"><span style="color: red;"> *</span>{{ "VendorCode1" |
                        translate}}
                      </div>
                    </nz-form-label>
                    <nz-form-control>
                      <input nz-input formControlName="VendorCode1" style="width: 300px;" />
                      <button nz-button nzType="primary" class="default-button" (click)="Search()">
                        <span nz-icon nzType="search"></span>
                        {{"Search" |
                        translate}}
                      </button>
                    </nz-form-control>
                  </nz-form-item>
                </div>

              </div>
              <div nz-row style="margin-left: 50px;">
                <div nz-col>
                  <nz-form-item>
                    <nz-form-label>
                      <div class="width-100-percent label-font">{{ "VendorName1" |
                        translate}}
                      </div>
                    </nz-form-label>
                    <nz-form-control>
                      <!-- <span formControlName="VendorName1"></span> -->
                      <input nz-input formControlName="VendorName1" style="width: 300px;" />
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>
              <div nz-row style="margin-left: 50px;">
                <div nz-col>
                  <nz-form-item>
                    <nz-form-label>
                      <div class="width-100-percent label-font">{{ "contactway" |
                        translate}}
                      </div>
                    </nz-form-label>
                  </nz-form-item>
                </div>
              </div>

              <nz-table #rowSelectionTable nzShowSizeChanger [nzData]="listOfData" nzSize="middle"
                [nzFrontPagination]="false" [nzShowPagination]='false' [nzPageSize]='pageSize' [nzPageIndex]='pageIndex'
                (nzCurrentPageDataChange)="onCurrentPageDataChange($event)" [nzScroll]="{ y: '500px' }">
                <thead>
                  <tr>
                    <th [(nzChecked)]="checked" [nzIndeterminate]="indeterminate"
                      (nzCheckedChange)="onAllChecked($event)" scope="col"></th>
                    <th scope="col">{{"linkman" | translate}}</th>
                    <th scope="col">{{"Companycode1212" | translate}}</th>
                    <th scope="col">{{"VendorAcount" | translate}}</th>
                    <th scope="col" nzWidth="200px">{{"mailbox" | translate}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of rowSelectionTable.data">
                    <td [nzChecked]="setOfCheckedId.has(data.id)" (nzCheckedChange)="onItemChecked(data.id, $event)">
                    </td>
                    <td>{{ data.vendorContact }}</td>
                    <td>{{ data.companyCode }}</td>
                    <td>{{ data.phone }}</td>
                    <td>{{ data.vendorMail}}</td>
                  </tr>
                </tbody>
              </nz-table>

            </ng-container>
          </nz-modal>


        </div>
      </div>

      <br>
      <div style="margin-top: -20px;">
        <div nz-cow style="margin-bottom: 10px;margin-left: 95.5%;">
          <div nz-col>
            <button nz-button nzType="primary" class="default-button" (click)="SendOut()">
              <span nz-icon nzType="send" nzTheme="outline"></span>
              {{"Send"| translate}}
            </button>
          </div>

        </div>
        <nz-card nzTitle="{{'ContractInformation' | translate}}" [nzExtra]="extraTemplateConcat">
          <div class="合同信息" style="margin-top: 10px;">
            <nz-table #colSpanTable [nzData]="contractdata[0]" style="margin-bottom: 10px" nzSize="middle"
              nzShowSizeChanger [nzFrontPagination]="false" [nzShowPagination]='false' [nzPageSize]='pageSize'
              [nzPageIndex]='pageIndex' [nzScroll]="{ y: '300px',x:'1320px' }">
              <thead>
                <tr>

                  <th scope="col" nzWidth="150px">{{
                    "contractname"
                    | translate}}</th>
                  <th scope="col" nzWidth="150px">{{
                    "ENcontractname" | translate}}</th>
                  <th scope="col" nzWidth="110px">{{
                    "contractversion" | translate}}</th>
                  <th scope="col" nzWidth="100px">{{ "Form Number" | translate}}</th>
                  <th scope="col" nzWidth="150px">{{ "background" | translate}}</th>
                  <th scope="col" nzWidth="150px">{{ "purpose" | translate}}</th>
                  <th scope="col" nzWidth="50px">{{ "state" | translate}}</th>
                  <th scope="col" nzWidth="50px">{{ "Site" | translate}}</th>
                  <th scope="col" nzWidth="100px">{{ "MDate" | translate}}</th>
                  <th scope="col" nzWidth="90px">{{ "MUser" | translate}}</th>
                  <th scope="col" nzWidth="70px">{{ "ApprovalTimeLimit" | translate}}</th>
                  <th scope="col" nzWidth="60px" [nzRight]="true">{{ "attachment" | translate}}</th>
                  <th scope="col" nzWidth="50px" [nzRight]="true">{{ "act" | translate}}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of contractdata[0];let i=index">

                  <td>{{data.chContractName}}</td>
                  <td>{{data.enContractName}}</td>
                  <td>{{data.versions}}</td>
                  <td>{{data.formNumber}}</td>
                  <td>{{data.backGround}}</td>
                  <td>{{data.goal}}</td>
                  <td>{{data.status}}</td>
                  <td>{{data.site}}</td>
                  <td>{{data.mDate | date:'yyyy-MM-dd'}}</td>
                  <td>{{data.mUser}}</td>
                  <td>{{data.approvalTimeLimit}}</td>
                  <td [nzRight]="true" style="cursor: pointer;"><span style="font-size: 20px;" nz-icon nzType="file"
                      nzTheme="twotone" (click)="download(data)" nz-tooltip nzTooltipTitle="{{data.fileName}}"></span>
                  </td>
                  <td style="text-align: center;" [nzRight]="true"> <a nz-popconfirm
                      nzPopconfirmTitle="{{'DeleteContractTemplate'| translate }}" nzPopconfirmPlacement="bottom"
                      (nzOnConfirm)="confirm(data,i)" (nzOnCancel)="cancel()">
                      <span nz-icon nzType="delete" nzTheme="outline" style="font-size: 20px;cursor: pointer;"></span>
                    </a>
                  </td>
                </tr>
              </tbody>
            </nz-table>
            <nz-pagination style="float:right;" [(nzPageIndex)]="pageIndex" [nzTotal]="total" [nzSize]="'small'"
              nzShowSizeChanger [nzPageSizeOptions]="[10,15,20]" [nzPageSize]='pageSize'
              (nzPageSizeChange)="nzPageSizeChange($event)" nzShowQuickJumper
              (nzPageIndexChange)="nzPageIndexChange($event)"></nz-pagination>
          </div>
        </nz-card>
      </div>
      <ng-template #extraTemplateConcat>

        <div nz-cow style="height: 20px;">
          <div nz-col style="display: flex; justify-content: flex-start;margin-top: -15px;">
            <button nz-button nzType="primary" class="default-button" (click)="ADDContra()">
              <span nz-icon nzType="plus" nzTheme="outline"></span>
              {{"Add" | translate}}
            </button>
          </div>
        </div>
      </ng-template>
      <br>
      <nz-card nzTitle="{{'VendorInformation' | translate}}" [nzExtra]="extraTemplate">

        <div class="厂商资讯" style="margin-top: 10px;">
          <nz-table #colSpanTable [nzData]="PaddingData[0]" style="margin-bottom: 10px" nzSize="middle"
            nzShowSizeChanger [nzFrontPagination]="false" [nzShowPagination]='false' [nzPageSize]='pageSize'
            [nzPageIndex]='pageIndex' (nzCurrentPageDataChange)="onCurrentPageDataChangeVendor($event)"
            [nzScroll]="{ y: '500px',x:'1520px' }">
            <thead>
              <tr>

                <th scope="col" nzWidth="10%">{{ "VendorCode1" | translate}}</th>
                <th scope="col" nzWidth="25%">{{ "VendorName1" | translate}}</th>
                <th scope="col" nzWidth="5%">{{ "Companycode1212" | translate}}</th>
                <th scope="col" nzWidth="10%">{{ "linkman" | translate}}</th>
                <th scope="col" nzWidth="10%">{{ "VendorAcount" | translate}}</th>
                <th scope="col" nzWidth="28%">{{ "VendorMail" | translate}}</th>
                <th scope="col" [nzRight]="true" nzWidth="8%">{{"UploadByPurchase" | translate}}</th>
                <th scope="col" nzWidth="5%" [nzRight]="true">{{ "act" | translate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of PaddingData[0];let i=index">

                <td>{{data.supplierId}}</td>
                <td>{{data.supplierName}}</td>
                <td>{{data.companyCode}}</td>
                <td>{{data.vendorContact}}</td>
                <td>{{data.phone}}</td>

                <td>{{data.vendorMail}}</td>

                <td [nzChecked]="setOfCheckedIdVendor.has(data.id)"
                  (nzCheckedChange)="onItemCheckedVendor(data.id, $event)" [nzRight]="true"></td>
                <td style="text-align: center;" [nzRight]="true"> <a nz-popconfirm
                    nzPopconfirmTitle="{{'deletevendorinformation' | translate}}" nzPopconfirmPlacement="bottom"
                    (nzOnConfirm)="deletevendor(data,i)" (nzOnCancel)="cancel()">
                    <span nz-icon nzType="delete" nzTheme="outline" style="font-size: 20px;cursor: pointer;"></span>
                  </a>
                </td>
              </tr>
            </tbody>
          </nz-table>
        </div>

      </nz-card>

      <ng-template #extraTemplate>
        <div nz-row style="height: 20px;">

          <div nz-col style="margin-top: -10px;">
            <button nz-button nzType="primary" class="default-button" (click)="isVendorOpen()">
              <span nz-icon nzType="plus" nzTheme="outline"></span>{{"Add"|translate}}
            </button>
          </div>

          <div nz-col style="margin-left: 15px;margin-top: -10px;">
            <button nz-button nzType="primary" class="default-button" (click)="DownloadTemplateExcel()" nz-tooltip
              nzTooltipTitle="{{'Sample' |translate}}"><span nz-icon
                nzType="download"></span>{{"DownloadExcel"|translate}}</button>
          </div>

          <div nz-col style="margin-left: 15px;margin-top: -10px;">
            <nz-upload [nzFileList]="fileList" [nzBeforeUpload]="beforeUpload">
              <button nz-button nzType="primary" class="default-button"> <span nz-icon
                  nzType="upload"></span>{{"UploadExcel"|translate}}</button>
            </nz-upload>

          </div>

        </div>
      </ng-template>

      <br>
      <div nz-row>

      </div>
    </form>
  </div>
</nz-spin>